import { useHead, useSeoMeta } from '@unhead/vue';

export interface RouteMeta {
  title: string;
  description: string;
  ogImage: string;
  ogType: string;
}

export const ROUTE_META: Record<string, RouteMeta> = {
  '/': {
    title: 'Sovi.fi | Sähköinen allekirjoitus',
    description:
      'Sovi on kotimainen helppokäyttöinen sähköinen PDF-allekirjoituspalvelu. Allekirjoita sopimukset turvallisesti ja sitovasti ilman kuukausimaksua.',
    ogImage: '/images/home-medium.webp',
    ogType: 'website',
  },
  '/hinnasto': {
    title: 'Hinnasto | Sovi.fi',
    description:
      'Sovi.fi-palvelun hinnat. Ei kuukausimaksua, ei sitovaa sopimusta. Maksat vain käytöstä. Aloita ilmaiseksi.',
    ogImage: '/images/home-medium.webp',
    ogType: 'website',
  },
  '/sahkoinen-allekirjoitus': {
    title:
      'Sähköinen allekirjoitus – Turvallinen ja helppo sähköinen allekirjoitus yrityksille | Sovi.fi',
    description:
      'Allekirjoita sopimukset sähköisesti nopeasti ja turvallisesti. Sovi.fi tarjoaa kotimaisen sähköisen allekirjoituspalvelun yrityksille ilman kuukausimaksuja – maksa vain käytöstä.',
    ogImage: '/images/sahkoinen-allekirjoitus-1.webp',
    ogType: 'website',
  },
  '/sahkoinen-allekirjoitus-yrityksille': {
    title:
      'Sähköinen allekirjoitus yrityksille – Käyttökohteet ja hyödyt | Sovi.fi',
    description:
      'Sähköinen allekirjoitus sopii kaikkien toimialojen yrityksille. Tutustu käyttökohteisiin, toimialaesimerkkeihin ja asiakirjamalleihin.',
    ogImage: '/images/content-11.webp',
    ogType: 'website',
  },
  '/sahkoinen-allekirjoitus-turvallisuus': {
    title:
      'Sähköisen allekirjoituksen turvallisuus ja juridinen pätevyys | Sovi.fi',
    description:
      'Sähköinen allekirjoitus on juridisesti pätevä EU:n eIDAS-asetuksen mukaisesti. Lue lisää tietoturvasta, jäljitettävyydestä ja paperisen sekä sähköisen allekirjoituksen eroista.',
    ogImage: '/images/sahkoinen-allekirjoitus-7.webp',
    ogType: 'website',
  },
  '/tyosopimuksen-sahkoinen-allekirjoitus': {
    title:
      'Työsopimuksen sähköinen allekirjoitus – Nopea ja turvallinen tapa allekirjoittaa työsopimus | Sovi.fi',
    description:
      'Allekirjoita työsopimus sähköisesti nopeasti ja turvallisesti. Nopeuta rekrytointia, vähennä paperityötä ja hallitse työsopimukset helposti Sovi.fi-palvelulla.',
    ogImage: '/images/tyosopimus-1.webp',
    ogType: 'website',
  },
  '/vuokrasopimuksen-sahkoinen-allekirjoitus': {
    title:
      'Vuokrasopimuksen sähköinen allekirjoitus – Allekirjoita vuokrasopimus verkossa | Sovi.fi',
    description:
      'Allekirjoita vuokrasopimus sähköisesti nopeasti ja turvallisesti. Sovi.fi helpottaa vuokrasopimusten lähettämistä, allekirjoittamista ja hallintaa verkossa.',
    ogImage: '/images/vuokrasopimus-1.webp',
    ogType: 'website',
  },
  '/ukk': {
    title: 'Usein kysytyt kysymykset sähköisestä allekirjoituksesta | Sovi.fi',
    description:
      'Vastaukset 10 yleisimpään kysymykseen sähköisestä allekirjoituksesta. Onko sähköinen allekirjoitus sitova? Mitä asiakirjoja voi allekirjoittaa? Lue lisää.',
    ogImage: '/images/ukk-1.webp',
    ogType: 'website',
  },
};

export const DEFAULT_META: RouteMeta = {
  title: 'Sovi.fi | Sähköinen allekirjoitus',
  description:
    'Sovi on kotimainen sähköinen PDF-asiakirjojen allekirjoituspalvelu. Allekirjoita sopimukset turvallisesti verkossa.',
  ogImage: '/images/home-medium.webp',
  ogType: 'website',
};

export function getRouteMeta(path: string): RouteMeta {
  return ROUTE_META[path] ?? DEFAULT_META;
}

export function useRouteMeta(options: {
  title: string;
  description: string;
  ogImage?: string;
}) {
  useHead({ title: options.title });
  useSeoMeta({
    description: options.description,
    ogTitle: options.title,
    ogDescription: options.description,
    ogImage: options.ogImage ?? '/images/home-medium.webp',
    ogType: 'website',
  });
}
